import { APIService } from "../../../../../../network/api/APIService";

export const AffiliateDashboardData = ({owner=null}) => {
    let endpoint = `/affiliate/dashboard/`;
    const params = [];
    if (owner !== null) params.push(`owner=${encodeURIComponent(owner)}`);

    if (params.length > 0) {
        endpoint += '?' + params.join('&');
    }

    return APIService({
        endpoint: endpoint,
        method: "GET",
        credentials: "include"
    });

}